export default function ServicesFallback() {
  return (
    <div className="px-3 mx-auto max-w-7xl xl:my-10 xxl:my-16 lg:px-4 xxl:px-10 animate-pulse">
      <div className="bg-grey50 w-full rounded-md h-[484px] lg:h-[388px]"></div>
    </div>
  );
}
